(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-text"] && !Shopify.designMode) return;
  try {
    
(() => {
  const active = new Map();
  function init(root) {
    if (active.has(root)) return;
    const timers = Array.from(root.querySelectorAll('.ups__timer'));
    const update = () => {
      const now = Date.now();
      timers.forEach(timer => {
        const start = Date.parse(timer.dataset.start);
        const end = Date.parse(timer.dataset.end);
        timer.hidden = !Number.isFinite(end) || !Number.isFinite(start) || now < start || now >= end;
        if (timer.hidden) return;
        const total = Math.max(0, Math.floor((end - now) / 1000));
        const parts = { days: Math.floor(total / 86400), hours: timer.dataset.hideDays === 'true' ? Math.floor(total / 3600) : Math.floor(total / 3600) % 24, minutes: Math.floor(total / 60) % 60, seconds: total % 60 };
        timer.querySelectorAll('[data-unit]').forEach(el => { el.textContent = String(parts[el.dataset.unit]).padStart(2, '0'); });
      });
    };
    update();
    const id = timers.length ? window.setInterval(update, 1000) : null;
    active.set(root, id);
    root.querySelectorAll('.ups__video-toggle').forEach(button => {
      button.addEventListener('click', () => {
        const video = button.parentElement.querySelector('video');
        if (!video) return;
        if (video.paused) video.play().catch(() => { video.controls = true; });
        else video.pause();
      });
    });
  }
  function scan(scope) { scope.querySelectorAll('.ups').forEach(init); }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.ups').forEach(root => { clearInterval(active.get(root)); active.delete(root); });
  });
  document.addEventListener('shopify:block:select', event => {
    const details = event.target.querySelector('.ups__details');
    if (details) details.open = true;
  });
})();

  } catch(e) { console.error(e); }
})();
})();
